import { GoAlert } from "react-icons/go";
import { useNavigate } from 'react-router-dom';

const ErrorComponent = () => {
    const navigate = useNavigate()
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: 'calc(100vh - 200px)' }}>
            <div className="container" style={{ fontSize: '20px' }}>
                <div className="row">
                    <div className="col-8">
                        <div className='row d-flex flex-column'>
                            <h1>Wykryto błąd aplikacji!</h1>
                            <span>Coś poszło nie tak, proszę spróbować ponownie.</span>
                            <span>W razie ponownego pojawienia się błędu skontaktuj się z administratorem stony.</span>
                        </div>
                        <div className="row mt-5">
                            <div className="col">
                                <button className='btn-app-primary' onClick={() => navigate('/')}>Powrót na strone główną</button>
                            </div>
                        </div>
                    </div>
                    <div className="col text-center">
                        <GoAlert size={200} className='error-text-color' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorComponent